import {
    setIsMobileLandscape,
    setIsMobilePortrait,
    setIsSmallIframeView,
    setIsTabletPortrait,
} from '../../store/slices/common-slice';
import { AppDispatch } from '../../store/widget/widget';

export interface BreakpointState {
    isTabletPortrait: boolean | null;
    isMobilePortrait: boolean | null;
    isMobileLandscape: boolean | null;
    isSmallIframe: boolean | null;
}

export const windowResizeHandler = (dispatch: AppDispatch, prev: BreakpointState): BreakpointState => {
    const isTabletPortrait = window.innerWidth <= 834;
    const isMobileLandscape = window.innerWidth <= 640;
    const isMobilePortrait = window.innerWidth <= 480;
    const isSmallIframe = window.innerWidth <= 330;

    if (prev.isTabletPortrait !== isTabletPortrait) {
        dispatch(setIsTabletPortrait(isTabletPortrait));
    }

    if (prev.isMobileLandscape !== isMobileLandscape) {
        dispatch(setIsMobileLandscape(isMobileLandscape));
    }

    if (prev.isMobilePortrait !== isMobilePortrait) {
        dispatch(setIsMobilePortrait(isMobilePortrait));
    }

    if (prev.isSmallIframe !== isSmallIframe) {
        dispatch(setIsSmallIframeView(isSmallIframe));
    }

    return {
        isTabletPortrait,
        isMobileLandscape,
        isMobilePortrait,
        isSmallIframe,
    };
};
